import React, { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';

import { StyleSheet, useWindowDimensions } from 'react-native';

import { Box } from 'components/ui';
import { getDesignToken } from 'styles/constants';
import { APP_MINIMUM_HEIGHT } from 'utils/constants';
import { isMobile } from 'utils/environment';

const KEYBOARD_DETECTION_THRESHOLD = 50;

export const Wrapper: FC<PropsWithChildren> = ({ children }) => {
  const { height: windowHeight, width: windowWidth } = useWindowDimensions();
  const [wrapperHeight, setWrapperHeight] = useState(Math.max(windowHeight, APP_MINIMUM_HEIGHT));
  const previousWidth = useRef(windowWidth);
  const baselineHeight = useRef(wrapperHeight);

  useEffect(() => {
    // On mobile web, the appearance of the virtual keyboard causes window.innerHeight to shrink.
    // If the height shrinks without a width change, it's almost certainly the keyboard opening.
    // We should NOT shrink the wrapper in this case, otherwise the app's scroll view shrinks too early
    // and causes a huge white space.
    const isWidthChanged = previousWidth.current !== windowWidth;
    let isKeyboardOpening = false;

    if (isMobile()) {
      isKeyboardOpening =
        !isWidthChanged && windowHeight < baselineHeight.current - KEYBOARD_DETECTION_THRESHOLD;
    }

    if (!isKeyboardOpening) {
      const newHeight = Math.max(windowHeight, APP_MINIMUM_HEIGHT);
      setWrapperHeight(newHeight);
      baselineHeight.current = newHeight;
    }

    previousWidth.current = windowWidth;
  }, [windowHeight, windowWidth]);

  return <Box style={[styles.wrapper, { height: wrapperHeight }]}>{children}</Box>;
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: getDesignToken('background-default'),
  },
});
